import { has, set, unset } from "lodash";
import { formatCurrency } from "../amount-term-lockout";

export function setupQuoteboost()
{
    $(document).on('click', 'input[name=quoteboost_accepted]', () => {
        updateQuoteBoost();
    });
}

export function updateQuoteBoost()
{
    let quoteboost = $('.form-group-quoteboost');
    if (quoteboost.length > 0) {
        let extrasInput = getExtrasInput(quoteboost);
        let amount = getLoanAmount(quoteboost.closest('form'));
        let term = getTerm(quoteboost.closest('form'));
        let acceptedInput = quoteboost.find('input[name="quoteboost_accepted"]').is(':checked');
        let show = shouldShow(amount, term);
        let newCombo = getNewAmountTermCombo(amount, term);
        quoteboost.toggleClass('hidden', !show);
        updateAllValues(newCombo, extrasInput, acceptedInput, show, quoteboost);
    }
}

function getLoanAmount(context)
{
    return $('[name=loan_amount]', context).val();
}

function getTerm(context)
{
    return $('[name=loan_term]', context).val();
}

function getExtrasInput(context)
{

    let extrasInput = context.closest('form').find('input[name=extras]');
    if (!extrasInput.length) {
        context.closest('form').append($('<input type="hidden" name="extras">'));
        extrasInput = context.closest('form').find('input[name=extras]');
        let fieldDefaults = JSON.stringify({
            'cookie_consent': (window.localStorage ? window.localStorage.getItem('cookie_consent_consent_given') : false)
        });
        extrasInput.val(fieldDefaults);
    }
    return extrasInput;
}

function shouldShow(amount, term)
{
    return amount > 500 && getNewAmountTermCombo(amount, term);
}

function getNewAmountTermCombo(amount, term)
{
    if (amount && term && window.quoteboost) {
        let key = amount + ',' + term;
        if (has(window.quoteboost, key)) {
            let result = window.quoteboost[key];
            return result;
        } else {
            return null;
        }
    } else {
        return null;
    }    
}

function updateAllValues(newAmountTermCombo, extrasInput, accepted, show, quoteboostElement)
{
    let extras = {};
    try {
        extras = JSON.parse(extrasInput.val()) ?? {};
    } catch(e) {}
    set(extras, 'quoteboost_variant', show ? 'dark' : 'hidden');
    set(extras, 'quoteboost_accepted', accepted);
    if (accepted && newAmountTermCombo) {
        set(extras, 'alternative_amount', newAmountTermCombo.amount);
        set(extras, 'alternative_term', newAmountTermCombo.term);
    } else {
        unset(extras, 'alternative_amount');
        unset(extras, 'alternative_term');
    }
    if (newAmountTermCombo) {
        quoteboostElement.find('.quoteboost-amount').text(formatCurrency(newAmountTermCombo.amount));
    } else {
        unset(extras, 'quoteboost_variant');
        unset(extras, 'quoteboost_accepted');
    }
    extrasInput.val(JSON.stringify(extras));
}